import { Route } from '@angular/router';
import { PartnerTier } from '@layout/partner-program/models/partner-tier.enum';
import { tierBenefits } from '@pages/partner-program/models/tier-benefits';

export const partnerProgramRoutes: Route[] = [
  {
    path: 'overview',
    loadComponent: () =>
      import('./components/overview-tab/overview-tab.component').then(({ OverviewTabComponent }) => OverviewTabComponent),
  },
  {
    path: 'silver',
    loadComponent: () =>
      import('./components/benefits-tab/benefits-tab.component').then(({ BenefitsTabComponent }) => BenefitsTabComponent),
    data: {
      tier: PartnerTier.Silver,
      benefits: tierBenefits.filter(({ isForSilver }) => isForSilver),
    },
  },
  {
    path: 'gold',
    loadComponent: () =>
      import('./components/benefits-tab/benefits-tab.component').then(({ BenefitsTabComponent }) => BenefitsTabComponent),
    data: {
      tier: PartnerTier.Gold,
      benefits: tierBenefits.filter(({ isForGold }) => isForGold),
    },
  },
  {
    path: 'platinum',
    loadComponent: () =>
      import('./components/benefits-tab/benefits-tab.component').then(({ BenefitsTabComponent }) => BenefitsTabComponent),
    data: {
      tier: PartnerTier.Platinum,
      benefits: tierBenefits.filter(({ isForPlatinum }) => isForPlatinum),
    },
  },
  {
    path: 'blue-diamond',
    loadComponent: () =>
      import('./components/benefits-tab/benefits-tab.component').then(({ BenefitsTabComponent }) => BenefitsTabComponent),
    data: {
      tier: PartnerTier.BlueDiamond,
      benefits: tierBenefits.filter(({ isForBlueDiamond }) => isForBlueDiamond),
    },
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'overview',
    data: { prefetchTarget: 'overview' },
  },
];
